import { Ref } from '@vue/composition-api';
import { getAccountTodayHMS, logger } from '@tt4b/ttam-utils';

import { i18n } from './../../../i18n';
// import { ValidationError } from '@tt4b/ttam-hooks';

export function useInitDataGet(opt: { timezone: Ref<string> }) {
  let name = '';
  try {
    if (!opt.timezone.value) {
      name = '';
    } else {
      const today = getAccountTodayHMS(opt.timezone.value, 'YYYYMMDDhhmmss');
      name = `${i18n.t('adgroup_title')} ${today}`;
    }
  } catch (e) {
    // 这里catch一下，因为这里报错，不至于阻断
    logger.error(e);
  }

  return {
    name,
  };
}

export enum ValidateConfig {
  MAX_NAME_LEN = 512
}
